import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10 3a.7.7 0 0 1 .7.7v.612c.88.138 1.523.537 1.958 1.06.52.623.692 1.362.692 1.879a.7.7 0 1 1-1.4 0c0-.247-.092-.653-.368-.984-.252-.303-.71-.607-1.582-.607-.729 0-1.208.23-1.5.513-.298.287-.45.675-.45 1.078 0 .368.127.673.455.997.355.352.929.708 1.796 1.12.884.42 1.64.831 2.171 1.341.572.549.878 1.205.878 2.04 0 .89-.365 1.658-.992 2.194-.455.388-1.027.636-1.658.74v.617a.7.7 0 1 1-1.4 0v-.623c-1.728-.319-2.65-1.794-2.65-2.928a.7.7 0 0 1 1.4 0c0 .554.594 1.591 1.95 1.591.636 0 1.128-.188 1.449-.463.312-.266.501-.643.501-1.128 0-.432-.135-.73-.447-1.03-.352-.337-.921-.667-1.804-1.087-.9-.428-1.65-.865-2.179-1.388-.555-.55-.87-1.2-.87-1.993 0-.758.29-1.517.876-2.084.451-.437 1.052-.736 1.774-.853V3.7A.7.7 0 0 1 10 3Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
